const utilsEvents = (() => {
    const FILE_UPLOAD_KEY = "fileData";
    const EXISTING_FILES_KEY = "browse_files";
    const TEXT_DATA = 'text_data';

    /**
     * Get the processed file path where `useThisFile` is `"true"`.
     * First, check FILE_UPLOAD_KEY, then EXISTING_FILES_KEY if not found.
     *
     * @returns {string|null} The formatted file path, or null if not found.
     */
    const getUseThisFilePath = () => {
        const useThis = getLocalStorageItem('useThisFile');
        const linkedInUseThis = getLocalStorageItem('linkedInUseThis');

         // Short-circuit if either flag is not explicitly "true"
        if (useThis !== 'true' && linkedInUseThis !== 'true') return '';

        const fileUploadData = JSON.parse(localStorage.getItem(FILE_UPLOAD_KEY)) || [];
        const fileUploadMatch = fileUploadData.find(file => file.useThisFile === "true");

        if (fileUploadMatch) {
            return fileUploadMatch.filePath.includes("usertemplates")
                ? `${fileUploadMatch.filePath.slice(fileUploadMatch.filePath.indexOf("usertemplates"))}.meta`
                : "";
        }

        // Only parse EXISTING_FILES_KEY if no match in FILE_UPLOAD_KEY
        const storedFiles = JSON.parse(localStorage.getItem(EXISTING_FILES_KEY)) || [];
        const storedFileMatch = storedFiles.find(file => file.useThisFile === "true");

        if (storedFileMatch) {
            return storedFileMatch?.filePath.includes("usertemplates")
                ? storedFileMatch.filePath.slice(storedFileMatch.filePath.indexOf("usertemplates"))
                : "";
        }

        // Only parse TEXT_DATA if no match in storedFiles
        const textData = JSON.parse(getLocalStorageItem(TEXT_DATA) || '[]');
        const textFileMatch = textData.length === 1 && textData[0].useThisFile === 'true' ? textData[0] : null;

        return textFileMatch?.filePath.includes('usertemplates')
            ?  textFileMatch.filePath.slice(textFileMatch.filePath.indexOf('usertemplates'))
            : "";

    };

    /**
     * Toggle layout based on the provided `themeName`.
     * If `themeName` contains "fang", apply `fangStyle`, otherwise apply `nonFangStyle`.
     *
     * @param {string} themeName - The theme name to check for "fang".
     */
    const toggleLayout = (themeName, iframeDoc, tinymceEditor) => {
        if (!iframeDoc || !iframeDoc[0]) {
            return;
        }

        const editorDoc = iframeDoc[0];

        if (themeName && themeName.includes('fang')) {
            nonFangStyle(editorDoc, tinymceEditor);
            fangStyle(editorDoc, tinymceEditor);
        } else {
            fangStyle(editorDoc, tinymceEditor);
            nonFangStyle(editorDoc, tinymceEditor);
        }
    };

 /**
 * Apply the "fang" layout styling inside TinyMCE.
 * Moves the date to row1, hides icons (date, location, GPA), removes `data-mce-style`, and applies <em> to location.
 */
const fangStyle = async (editorDoc, tinymceEditor) => {
    const entries = editorDoc.querySelectorAll('.dynamic-entry-container');

    for (const entry of entries) {
        if (entry.classList.contains('toggled')) continue;

        const row1 = entry.querySelector('.dynamic-row1');
        const row1col3 = row1.children[2];

        const row2 = entry.querySelector('.dynamic-row2');
        const dateCell = row2.querySelector('.dynamic-date');
        const locCell = row2.querySelector('.dynamic-location');
        const gpaIcon = row2.querySelector('.gpa-icon'); // Select the GPA icon

        if (row1col3){
            row1col3.innerHTML = dateCell.innerHTML;
            row1col3.style.textAlign = 'right';
            row1col3.classList.remove('dynamic-empty');
        }

        let locText = locCell.innerHTML.replace(/<\/?h5.*?>/g, '').trim();
        if (!locText.includes('<em>')) {
            locCell.innerHTML = locCell.innerHTML.replace(locText, `<em>${locText}</em>`);
        }
        locCell.style.textAlign = 'right';

        setTimeout(() => {
            const dateIcon = row1col3.querySelector('.mark-fapkw');
            const locationIcon = locCell.querySelector('.mark-fapkw');

            if (dateIcon) dateIcon.style.display = 'none';
            if (locationIcon) locationIcon.style.display = 'none';
            if (gpaIcon) gpaIcon.style.display = 'none'; // Hide GPA icon
        }, 10);

        dateCell.innerHTML = '';
        dateCell.classList.add('dynamic-empty');
        dateCell.style.textAlign = 'left';

        // Remove `data-mce-style` from all modified elements
        [row1col3, dateCell, locCell, gpaIcon, ...entry.querySelectorAll('.mark-fapkw')]
            .forEach(el => {
                if (el && el.hasAttribute('data-mce-style')) {
                    el.removeAttribute('data-mce-style');
                }
            });

        entry.classList.add('toggled');
    }

};

/**
 * Revert to the default layout inside TinyMCE.
 * Moves the date back to row2, restores icons (date, location, GPA), removes `data-mce-style`, and removes <em> from location.
 */
const nonFangStyle = async (editorDoc, tinymceEditor) => {
    const entries = editorDoc.querySelectorAll('.dynamic-entry-container');

    for (const entry of entries) {
        if (!entry.classList.contains('toggled')) continue;

        const row1 = entry.querySelector('.dynamic-row1');
        const row1col3 = row1.children[2];

        const row2 = entry.querySelector('.dynamic-row2');
        const dateCell = row2.querySelector('.dynamic-date');
        const locCell = row2.querySelector('.dynamic-location');
        const gpaIcon = row2.querySelector('.gpa-icon'); // Select the GPA icon

        if (row1col3){
            dateCell.innerHTML = row1col3.innerHTML;
            dateCell.classList.remove('dynamic-empty');
            dateCell.style.textAlign = 'left';


            row1col3.innerHTML = '';
            row1col3.classList.add('dynamic-empty');
            row1col3.style.textAlign = 'left';
        }

        locCell.innerHTML = locCell.innerHTML.replace(/<\/?em>/g, '');
        locCell.style.textAlign = 'left';

        setTimeout(() => {
            const dateIcon = dateCell.querySelector('.mark-fapkw');
            const locationIcon = locCell.querySelector('.mark-fapkw');


            if (dateIcon) dateIcon.style.display = 'inline';
            if (locationIcon) locationIcon.style.display = 'inline';
            if (gpaIcon) gpaIcon.style.display = 'inline'; // Restore GPA icon
        }, 10);

        // Remove `data-mce-style` from all modified elements
        [row1col3, dateCell, locCell, gpaIcon, ...entry.querySelectorAll('.mark-fapkw')]
            .forEach(el => {
                if (el && el.hasAttribute('data-mce-style')) {
                    el.removeAttribute('data-mce-style');
                }
            });

        entry.classList.remove('toggled');
    }
};



    const toggleDateAlignment = (themeName, iframeDoc, tinymceEditor) => {
        if (!iframeDoc || !iframeDoc[0]) {
            return;
        }

        const editorDoc = iframeDoc[0];

        if (themeName && themeName.includes('fang')) {
            nonFangDateStyle(editorDoc, tinymceEditor);
            fangDateStyle(editorDoc, tinymceEditor);
        } else {
            fangDateStyle(editorDoc, tinymceEditor);
            nonFangDateStyle(editorDoc, tinymceEditor);
        }
    };

  /**
 * Apply "fang" style for all date entries.
 * Moves the date to the right, hides the calendar icon, removes the "bold-text" class, and removes `data-mce-style`.
 */
const fangDateStyle = async (editorDoc, tinymceEditor) => {
    const dateEntries = editorDoc.querySelectorAll('.date-single-date');

    for (const dateContainer of dateEntries) {
        if (!dateContainer || dateContainer.classList.contains('right-aligned')) continue;

        const icon = dateContainer.querySelector('.date-single-icon');
        const dateText = dateContainer.querySelector('.date-single-text');

        // Apply "right-aligned" class
        dateContainer.classList.add('right-aligned');
        dateContainer.style.textAlign = 'right';

        // Hide the calendar icon
        if (icon) icon.classList.add('hidden-icon');

        // Remove the "bold-text" class instead of modifying <strong>
        if (dateText) {
            dateText.classList.remove('bold-text');
        }

        // Remove `data-mce-style` from affected elements
        [dateContainer, dateText, icon, ...dateContainer.querySelectorAll('.mark-fapkw')]
            .forEach(el => {
                if (el && el.hasAttribute('data-mce-style')) {
                    el.removeAttribute('data-mce-style');
                }
            });
    }


};

/**
 * Restore the default alignment for all date entries.
 * Moves the date back to the left, shows the calendar icon, re-adds the bold class, and removes `data-mce-style`.
 */
const nonFangDateStyle = async (editorDoc, tinymceEditor) => {
    const dateEntries = editorDoc.querySelectorAll('.date-single-date');

    for (const dateContainer of dateEntries) {
        if (!dateContainer || !dateContainer.classList.contains('right-aligned')) continue;

        const icon = dateContainer.querySelector('.date-single-icon');
        const dateText = dateContainer.querySelector('.date-single-text');

        // Remove "right-aligned" class
        dateContainer.classList.remove('right-aligned');
        dateContainer.style.textAlign = 'left';

        // Show the calendar icon again
        if (icon) icon.classList.remove('hidden-icon');

        // Reapply "bold-text" class instead of modifying <strong>
        if (dateText) {
            dateText.classList.add('bold-text');
        }

        // Remove `data-mce-style` from affected elements
        [dateContainer, dateText, icon, ...dateContainer.querySelectorAll('.mark-fapkw')]
            .forEach(el => {
                if (el && el.hasAttribute('data-mce-style')) {
                    el.removeAttribute('data-mce-style');
                }
            });
    }

};


    return {
        getUseThisFilePath,
        toggleLayout,
        toggleDateAlignment
    };

})();

export default utilsEvents;
